import * as React from "react";
import { forwardRef } from "react";
const SvgVk = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 48, height: 48, rx: 14, fill: "#0077FF" }), /* @__PURE__ */ React.createElement("path", { d: "M25.37 34.25C14.1 34.25 7.67 26.52 7.4 13.67h5.65c.18 9.43 4.33 13.42 7.62 14.24V13.67h5.32v8.13c3.25-.35 6.67-4.05 7.83-8.13h5.32c-.89 5.02-4.62 8.72-7.28 10.24 2.66 1.23 6.93 4.46 8.56 10.34h-5.85c-1.27-3.91-4.4-6.94-8.58-7.35v7.35h-.62Z", fill: "white" }));
const ForwardRef = forwardRef(SvgVk);
export { ForwardRef as ReactComponent };
